import { Repository } from '../servics/httpsServics';

const serviceTypes = 'service-types';
export function getAllServiceTypes() {
  return Repository.get(serviceTypes);
}
